(function () {
  function init(section) {
    if (section.dataset.fpReady) return;

    section.dataset.fpReady = 'true';

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.add('is-visible');
            observer.disconnect();
          }
        });
      },
      { threshold: 0.12 }
    );

    observer.observe(section);

    var media = [].slice.call(
      section.querySelectorAll('[data-fp-media]')
    );

    var thumbs = [].slice.call(
      section.querySelectorAll('[data-fp-thumb]')
    );

    var dots = [].slice.call(
      section.querySelectorAll('[data-fp-dot]')
    );

    var active = 0;

    function show(index) {
      if (index < 0 || index >= media.length) return;

      if (index !== active) {
        var old = media[active];

        old.classList.remove('is-active');
        old.classList.add('is-leaving');

        window.setTimeout(function () {
          old.classList.remove('is-leaving');
        }, 720);

        media[index].classList.add('is-active');
      }

      active = index;

      thumbs.forEach(function (element, itemIndex) {
        element.classList.toggle(
          'is-active',
          itemIndex === index
        );
      });

      dots.forEach(function (element, itemIndex) {
        element.classList.toggle(
          'is-active',
          itemIndex === index
        );
      });
    }

    thumbs.forEach(function (element, index) {
      element.addEventListener('click', function () {
        show(index);
      });
    });

    dots.forEach(function (element, index) {
      element.addEventListener('click', function () {
        show(index);
      });
    });

    var quantity = section.querySelector(
      '[data-fp-quantity]'
    );

    var minus = section.querySelector('[data-fp-minus]');
    var plus = section.querySelector('[data-fp-plus]');

    if (minus) {
      minus.addEventListener('click', function () {
        quantity.value = Math.max(
          1,
          (Number(quantity.value) || 1) - 1
        );
      });
    }

    if (plus) {
      plus.addEventListener('click', function () {
        quantity.value =
          (Number(quantity.value) || 1) + 1;
      });
    }

    var select = section.querySelector(
      '[data-fp-variant]'
    );

    var input = section.querySelector(
      '[data-fp-variant-id]'
    );

    var price = section.querySelector('[data-fp-price]');
    var add = section.querySelector('[data-fp-add]');
    var buy = section.querySelector('[data-fp-buy-now]');

    if (add) {
      var addLabel = add.querySelector('span');

      add.dataset.defaultLabel =
        (addLabel && addLabel.textContent) ||
        'ADD TO CART';
    }

    function variantChange() {
      if (!select) return;

      var option = select.options[select.selectedIndex];
      var available =
        option.dataset.available === 'true';

      input.value = option.value;

      if (price) {
        price.textContent = option.dataset.price;
      }

      if (add) {
        add.disabled = !available;

        var label = add.querySelector('span');

        if (label) {
          label.textContent = available
            ? add.dataset.defaultLabel
            : 'Sold out';
        }
      }

      if (buy) {
        buy.disabled = !available;
      }

      if (option.dataset.mediaId) {
        var target = media.findIndex(function (element) {
          return (
            element.dataset.mediaId ===
            option.dataset.mediaId
          );
        });

        if (target > -1) {
          show(target);
        }
      }
    }

    if (select) {
      select.addEventListener(
        'change',
        variantChange
      );
    }

    if (buy) {
      buy.addEventListener('click', function () {
        if (buy.disabled) return;

        var id = input && input.value;
        var selectedQuantity = Math.max(
          1,
          Number(quantity && quantity.value) || 1
        );

        var root =
          window.Shopify &&
          Shopify.routes &&
          Shopify.routes.root
            ? Shopify.routes.root
            : '/';

        if (id) {
          window.location.href =
            root +
            'cart/' +
            id +
            ':' +
            selectedQuantity +
            '?checkout';
        }
      });
    }
  }

  function boot() {
    document
      .querySelectorAll(
        '[data-leile-featured-product]'
      )
      .forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      boot
    );
  } else {
    boot();
  }

  document.addEventListener(
    'shopify:section:load',
    boot
  );
})();